import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatError } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast, Toaster } from "sonner";

const BG = "https://images.unsplash.com/photo-1552664730-d307ca884978?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(name, email, password);
      toast.success("Akun berhasil dibuat");
      navigate("/");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen relative overflow-hidden bg-[#151A18]">
      <div className="absolute inset-0">
        <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover"
             style={{ filter: "blur(6px) saturate(1.05)", transform: "scale(1.05)" }}/>
        <div className="absolute inset-0" style={{ background: "linear-gradient(135deg, rgba(21,26,24,0.72) 0%, rgba(45,71,57,0.60) 60%, rgba(21,26,24,0.85) 100%)" }}/>
      </div>

      <div className="relative z-10 min-h-screen flex items-center justify-center p-6">
        <form onSubmit={submit} data-testid="register-form"
              className="w-full max-w-sm rounded-2xl p-8 sm:p-10 backdrop-blur-2xl bg-white/10 border border-white/20 shadow-[0_20px_80px_-20px_rgba(0,0,0,0.6)]">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-9 h-9 bg-[#D99C3B] flex items-center justify-center font-display font-bold text-[#151A18] rounded-sm">A</div>
            <div className="font-display text-lg text-white">Adika Cipta Kreasindo</div>
          </div>
          <div className="mb-8">
            <div className="text-[10px] tracking-[0.3em] uppercase text-white/60 mb-2">Daftar</div>
            <h2 className="font-display text-3xl text-white tracking-tight">Buat akun<br/>Adika Cipta Kreasindo.</h2>
            <p className="text-sm text-white/60 mt-2">Gratis, tanpa kartu kredit.</p>
          </div>
          <div className="space-y-4">
            <div>
              <Label className="text-[10px] uppercase tracking-[0.2em] text-white/70">Nama Lengkap</Label>
              <Input data-testid="register-name" value={name} onChange={(e)=>setName(e.target.value)} required
                     className="mt-1.5 rounded-lg h-11 bg-white/5 border-white/20 text-white placeholder:text-white/40 focus-visible:ring-2 focus-visible:ring-[#D99C3B]"/>
            </div>
            <div>
              <Label className="text-[10px] uppercase tracking-[0.2em] text-white/70">Email</Label>
              <Input data-testid="register-email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required
                     className="mt-1.5 rounded-lg h-11 bg-white/5 border-white/20 text-white placeholder:text-white/40 focus-visible:ring-2 focus-visible:ring-[#D99C3B]"/>
            </div>
            <div>
              <Label className="text-[10px] uppercase tracking-[0.2em] text-white/70">Password</Label>
              <Input data-testid="register-password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required
                     className="mt-1.5 rounded-lg h-11 bg-white/5 border-white/20 text-white placeholder:text-white/40 focus-visible:ring-2 focus-visible:ring-[#D99C3B]"/>
            </div>
          </div>
          <Button disabled={busy} data-testid="register-submit"
                  className="w-full mt-8 h-12 rounded-lg bg-[#D99C3B] hover:bg-[#c48a2f] text-[#151A18] font-medium shadow-lg shadow-[#D99C3B]/20">
            {busy ? "Memproses…" : "Buat Akun"}
          </Button>
          <div className="text-sm text-white/60 mt-6 text-center">
            Sudah punya akun? <Link to="/login" className="text-[#D99C3B] hover:text-[#F5B84A] font-medium underline underline-offset-4">Masuk</Link>
          </div>
        </form>
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
}
